// extracted by mini-css-extract-plugin
export default {"pane":"_f95d4c7","content":"_5713a694","trigger":"_1d973885","arrow":"_97fd3284","arrowDown":"_4a3b3996","negotiationDisclaimer":"_7e29201d"};